import { useContext } from 'react';
import { useManageVehicleTypeGroups } from '~/common/api';
import { ITranslatedVehicleTypeGroup } from '~/common/types';
// eslint-disable-next-line @wyz/module/invalid-import
import {
  CustomerSelectorAvailabilityContext,
  FunctionalContext,
} from '~/purchase/context/contexts';

export type IActiveVehicleTypeGroupReturnType =
  | {
      isSuccess: true;
      data: { data: ITranslatedVehicleTypeGroup[] };
    }
  | {
      isSuccess: false;
      data: undefined;
    };

export function useActiveVehicleTypeGroups(): IActiveVehicleTypeGroupReturnType {
  const customerSelectorAvailable = useContext(
    CustomerSelectorAvailabilityContext,
  );
  const purchaseContext = useContext(FunctionalContext);
  const hasSelectedCustomer =
    customerSelectorAvailable &&
    purchaseContext !== undefined &&
    purchaseContext.state.targetCustomer !== undefined;

  const { coreVehicleTypeGroup } = useManageVehicleTypeGroups({
    coreVehicleTypeGroup: { enabled: !hasSelectedCustomer },
  });

  const data = hasSelectedCustomer
    ? ((purchaseContext?.state.targetCustomer?.settingTemplate
        ?.vehicleTypeGroups ?? []) as ITranslatedVehicleTypeGroup[])
    : (coreVehicleTypeGroup.data?.data ?? []);

  return hasSelectedCustomer || coreVehicleTypeGroup.isSuccess
    ? {
        isSuccess: true,
        data: { data },
      }
    : {
        isSuccess: false,
        data: undefined,
      };
}
